const webStorageFieldPrefix = 'geo3.'

export function setItemLocalStorage(key: string, value: any) {
    localStorage.setItem(webStorageFieldPrefix + key, JSON.stringify(value))
}

export function getItemLocalStorage(key: string) {
    try {
        let itemLocal = localStorage.getItem(webStorageFieldPrefix + key)
        let item = itemLocal && JSON.parse(itemLocal)
        return item
    } catch (error) {
        console.error(`Ошибка получения значения ${key} из localStorage`)
    }
}

export function setItemSessionStorage(key: string, value: any) {
    sessionStorage.setItem(webStorageFieldPrefix + key, JSON.stringify(value))
}

export function getItemSessionStorage(key: string) {
    try {
        let itemLocal = sessionStorage.getItem(webStorageFieldPrefix + key)
        let item = itemLocal && JSON.parse(itemLocal)
        return item
    } catch (error) {
        console.error(`Ошибка получения значения ${key} из sessionStorage`)
    }
}

export function getItemWebStorage(key: string) {
    const persist = getItemLocalStorage("persist")
    let item: any
    if (persist) {
        item = getItemLocalStorage(key)
    } else {
        item = getItemSessionStorage(key)
    }
    return item
}

export function setItemWebStorage(key: string, value: any) {
    const persist = getItemLocalStorage("persist")
    if (persist) {
        setItemLocalStorage(key, value)
    } else {
        setItemSessionStorage(key, value)
    }
}

export function clearWebStorage() {
    const persist = getItemLocalStorage("persist")
    if (persist) {
        const lastEnteredDataBaseSave: any = getItemLocalStorage("lastEnteredDatabase")
        localStorage.clear()
        setItemLocalStorage("persist", false)
        if (lastEnteredDataBaseSave) {
            setItemLocalStorage("lastEnteredDatabase", lastEnteredDataBaseSave)
        }
    }
    sessionStorage.clear()
}